
import React, { useState } from 'react';

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "民間資格とは何ですか？",
      answer: "国家資格ではなく民間団体が発行する資格です。DJI農業ドローン運用には農業ドローン協議会の民間資格が業界標準として必要です。"
    },
    {
      question: "初心者でも受講できますか？",
      answer: "はい、未経験者コースは初心者向け。基礎から丁寧に指導しますのでご安心ください。"
    },
    {
      question: "他団体のドローン資格を持っています",
      answer: "経験者コースをご受講ください。受講期間・費用が軽減されます。"
    },
    {
      question: "試験不合格の場合は？",
      answer: "再試験を受けていただけます。追加講習が必要な場合は別途ご相談ください。"
    },
    {
      question: "オンライン教習とオフライン教習の違いは？",
      answer: "オフライン教習は座学も対面で実施し、インストラクターが直接指導するため確実に技術を習得できます。時間をかけてじっくり学びたい方におすすめです。"
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">よくある質問</h2>
          <p className="text-xl sm:text-lg text-gray-600">受講に関するよくあるご質問</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <button
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-lg font-bold text-[#2A6041] pr-4">{faq.question}</h3>
                <div className="flex-shrink-0">
                  <i className={`ri-arrow-down-s-line text-2xl text-[#76B947] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
